import React from "react";
import { OrdersToolbarProps } from "../../../../shared/services/interface";
import SearchField from "./SearchField";
import ImportButton from "./ImportButton";
import ExportSelect from "./ExportSelect";
import FilterSelect from "./FieldSelect";

const OrdersToolbar: React.FC<OrdersToolbarProps> = ({
  searchTerm,
  handleSearch,
  inputRef,
  handleImport,
  handleExport,
  orders,
  selectedDate,
  selectedDate2,
  selectedOption,
  handleFilterChange,
}) => {
  return (
    <div className="w-full mx-auto px-4">
      <div className="mt-4 w-full px-5 min-h-[60px] mb-3 flex items-center justify-end gap-4 ">
        <div className="w-full flex flex-wrap justify-between gap-2 p-2">
          <FilterSelect
            selectedOption={selectedOption}
            handleFilterChange={handleFilterChange}
          />
          <ExportSelect
            orders={orders}
            selectedDate={selectedDate}
            selectedDate2={selectedDate2}
            handleExport={handleExport}
          />
          <ImportButton inputRef={inputRef} handleImport={handleImport} />
          <SearchField searchTerm={searchTerm} handleSearch={handleSearch} />
        </div>
      </div>
    </div>
  );
};

export default OrdersToolbar;
